"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const next_components_icon_n_1 = __importDefault(require("@gerenciatd/next.components.icon-n"));
const next_components_text_info_n_1 = __importDefault(require("@gerenciatd/next.components.text-info-n"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const constants_1 = require("../../constants");
class DefaultOptions extends react_1.Component {
    constructor() {
        super(...arguments);
        this.getProperLink = (item, userType) => {
            if (userType === constants_1.TELCO && item && item.linkTelco) {
                return item.linkTelco;
            }
            if (userType === constants_1.LEGADO && item && item.linkLegado) {
                return item.linkLegado;
            }
            if (item.link) {
                return item.link;
            }
            return null;
        };
        this.getProperTaggingInfo = (item, userType) => {
            if (userType === constants_1.TELCO && item && item.taggingInfoTelco) {
                return item.taggingInfoTelco;
            }
            if (userType === constants_1.LEGADO && item && item.taggingInfoLegado) {
                return item.taggingInfoLegado;
            }
            if (item.taggingInfo) {
                return item.taggingInfo;
            }
            return null;
        };
    }
    shouldComponentUpdate(nextProps) {
        const cndUserType = nextProps.userType !== this.props.userType;
        const cntSegment = nextProps.segment !== this.props.segment;
        return cndUserType || cntSegment;
    }
    render() {
        const { userType, segment } = this.props;
        let { info } = this.props;
        if (!info) {
            return null;
        }
        // filtering no visible
        info = info.filter((item) => item.visible === true);
        return (react_1.default.createElement("div", { className: "DefaultOptions" },
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement("div", { className: "SliderGapDO" }, info.map((item) => {
                    const taggingInfo = this.getProperTaggingInfo(item, userType);
                    const link = this.getProperLink(item, userType);
                    const { svgId, text, /* stamp, badge, */ kind } = item;
                    return (react_1.default.createElement("div", { key: `ItemDO-${svgId}`, className: `ItemDO ${svgId}`, style: { position: 'relative' } },
                        react_1.default.createElement("div", { className: 'icon-gap' },
                            react_1.default.createElement(next_components_icon_n_1.default, { id: svgId, color: "black", size: 30, kind: kind })),
                        react_1.default.createElement("div", { className: 'text-gap' },
                            react_1.default.createElement(next_components_text_info_n_1.default, { text: text, align: "center", fontType: "font-light", size: "caption02", color: "grey4", display: "block" })),
                        react_1.default.createElement(next_components_custom_link_1.default, { className: "clLink", href: link, taggingInfo: taggingInfo })));
                })))));
    }
}
exports.default = DefaultOptions;
//# sourceMappingURL=index.js.map